import axios from 'axios';

// This file is for testing API connections
const apiUrl = process.env.REACT_APP_API_URL || '/api';

// Function to test API connectivity
export const testApiConnection = async () => {
  try {
    const response = await axios.get(`${apiUrl}/health`);
    console.log('API connection successful:', response.data);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('API connection failed:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

// Export the API URL for reference
export const API_URL = apiUrl;
